import { _ as _overArg } from "./auth-service-tools1281.js";
var overArg = _overArg;
var nativeKeys = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys;
export { _nativeKeys as _ };